import React from 'react';
import PropTypes from 'prop-types';

import styles from './MoobileTooltip.css';

const MobileTooltip = ({ children, url, translations, closeMobileTooltip }) => (
  <div
    className={styles.Wrapper}
    onClick={closeMobileTooltip}
    onKeyPress={undefined}
    role="button"
    tabIndex="0"
  >
    <div className={styles.Content}>
      {children}
    </div>
    <div className={styles.ButtonSection}>
      <a onClick={e => e.stopPropagation()} href={url} className={styles.Link}>
        {translations['Show game']}
      </a>
    </div>
  </div>
);

MobileTooltip.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]).isRequired,
  url: PropTypes.string.isRequired,
  translations: PropTypes.shape().isRequired,
  closeMobileTooltip: PropTypes.func.isRequired
};

export default MobileTooltip;



// WEBPACK FOOTER //
// ./src/components/MobileTooltip/MobileTooltip.js